import { ThemeColors, TinyDropdownMenu } from '@octopus-do/octopus-storybook'
import {
  CommentReadsActions,
  selectLatestForeignCreatedAt,
} from '@store/reducers/commentReads'
import type React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import type { ThreadListItem } from '../../types'
import { Content, Trigger } from './components'

interface Props {
  thread: ThreadListItem
  className: string
}

// The row's menu: Mark as unread for a place the viewer has read. Only
// foreign comments count as unread, so a place with nothing but the viewer's
// own gets no menu, nor does a guest (no read state), a resolved pin (never
// lights up) or a row that is unread already
export const LinkActions: React.FC<Props> = ({
  thread: { id, resolved, unread },
  className,
}) => {
  const dispatch = useDispatch()
  const markable = useSelector(selectLatestForeignCreatedAt(id)) !== null

  if (!markable || resolved || unread) {
    return null
  }

  const onClick = () => dispatch(CommentReadsActions.markUnread({ target: id }))

  // the row itself opens the place on click, which would mark it read again
  const stop = (event: React.MouseEvent) => event.stopPropagation()

  return (
    <span className={className} onClick={stop}>
      <TinyDropdownMenu.Root
        onClick={onClick}
        content={Content}
        align="end"
        sideOffset={4}
        theme={ThemeColors.light}
      >
        <Trigger />
      </TinyDropdownMenu.Root>
    </span>
  )
}
